import { useCallback } from 'react';
import { testId } from 'ui-components/services/testid-service';
import styles from './inline-tabs.module.css';
import { TabListContainer } from './tab-list-container/tab-list-container';
import { TabList } from './tab-list/tab-list';
import { TabPanel } from './tab-panel/tab-panel';
import { Tab } from './tab/tab';
import { Tabs } from './tabs';

/**
 * @typedef {import('../../../prop-types/tabs-data').TabData} TabData
 */
/**
 * @param {object} props
 * @param {TabData[]} [props.data] - list of tabs to display with the required information
 * @param {number} [props.defaultTabIndex] - starting index of the tab section
 * @param {(tabId: number|string, index: number) => void} [props.onSelectedTabIndexChange] - function to call when the tab index has changed (user has clicked on a different tab)
 * @returns {JSX.Element}
 */
export const InlineTabs = ({ data = [], defaultTabIndex = 0, onSelectedTabIndexChange }) => {
  const onTabChange = useCallback(
    (tabIndex) => {
      onSelectedTabIndexChange?.(data[tabIndex].tabId, tabIndex);
    },
    [data, onSelectedTabIndexChange],
  );

  return (
    <Tabs className={styles.tabs} defaultIndex={defaultTabIndex} onSelectedTabIndexChange={onTabChange}>
      <TabListContainer>
        <TabList>
          {data.map((tabData) => (
            <Tab
              key={tabData.tabId}
              {...testId(tabData.tabId)}
              className={styles['inline-tab-button']}
              selectedClassName={styles['inline-tab-button-selected']}
            >
              {tabData.title}
            </Tab>
          ))}
        </TabList>
      </TabListContainer>
      {data.map((tabData) => (
        <TabPanel key={tabData.tabId}>{tabData.content}</TabPanel>
      ))}
    </Tabs>
  );
};
